export default {
    terminals: [],
}
